import React from 'react';
import '../CSS/Profile/BarryHasenkopfProfile.css';

const BarryHasenkopfProfile: React.FC = () => {
  const imagePath = `${process.env.PUBLIC_URL || ''}/assets/Web Version/Team Page/Our Team/barry-hasenkopf-image.png`;
  const linkedInIcon = `${process.env.PUBLIC_URL || ''}/assets/Web Version/Icons/linkedin-blue-icon.svg`;

  return (
    <div className="profile-page">
      <div className="profile-header">
        <div className="profile-picture-container">
          <img 
            src={imagePath}
            alt="J. Barry Hasenkopf"
            className="profile-picture"
          />
        </div>
      </div>
      <div className="profile-content">
        <h1 className="profile-name">J. Barry Hasenkopf</h1>
        <div className="profile-title-container">
          <p className="profile-title">Senior Consultant</p>
          <a href="https://www.linkedin.com/in/barry-hasenkopf-1224121/" target="_blank" rel="noopener noreferrer">
            <img 
              src={linkedInIcon}
              alt="LinkedIn"
              className="profile-linkedin-icon"
            />
          </a>
        </div>
        <div className="profile-desc">
          <p>
            Joseph Barry Hasenkopf (Barry) is Chief Executive Officer with 30 years of experience as an executive consultant. His experience spans multiple industries, cultures, and geographies. He is a proven leader committed to the growth, education, and enrichment of his clients at every level of their career.
          </p>
          <p>
            Barry has assisted some of the largest global professional consulting firms, including Ernst & Young, Capgemini, HP, IBM, and Tata Consulting.
          </p>
          <p>
            He has taught leadership, communication, and relationship skills to business students at Georgia State University, J. Mack Robinson College of Business. His academic experience includes working with professors and department chairs as an adjunct professor. He helped prepare and deliver a successful enterprise business process curriculum within the Information Systems, Master of Science degree program.
          </p>
          <p>
            As an executive at Myers McRae, Barry is committed to continuing the strategic direction and quality services that have earned the firm national recognition. Myers McRae is named by editors and analysts at Hunt Scanlon Media as one of the "Top 50 Education / Non-Profit Search Firms" in a special edition of Executive Search Review. The selected firms are considered "most prominent trailblazers" in education and non-profit searches.
          </p>
          <p>
            Barry holds a Bachelor of Science degree in computer science with a minor in mathematics and Russian from Edinboro University of Pennsylvania (now PennWest Edinboro) and a Master of Business Administration (MBA) degree with a concentration in finance from the University of Pittsburgh, Joseph M. Katz Graduate School of Business.
          </p>
        </div>
      </div>
    </div>
  );
};

export default BarryHasenkopfProfile;

